import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/icon-lottrackr.svg'


const _hoisted_1 = { class: "header-center" }
const _hoisted_2 = {
  key: 0,
  class: "wrapper-logo"
}
const _hoisted_3 = {
  key: 1,
  class: "estate-map-wrapper-logo"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", [{ 'estate-header': $props.estate }, { 'over-all': $props.overAll }]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-container", { container: $props.estate }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (!$props.estate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              ($props.estate?._id)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: $setup.estateMapRoute
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", { src: $setup.logoUrl }, null, 8, _hoisted_4)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]))
      ])
    ], 2)
  ], 2))
}